/**
 * The one JSON syntax-highlighting map (docs/brand.md → Code and syntax colours). The
 * `syntax-*` colours are per-theme tokens in index.css; class names stay literal so
 * Tailwind's scanner finds them.
 */
export type SyntaxToken = 'key' | 'string' | 'number' | 'boolean' | 'null' | 'punctuation';

export const SYNTAX_CLASS: Record<SyntaxToken, string> = {
  key: 'text-syntax-key',
  string: 'text-syntax-string',
  number: 'text-syntax-number',
  boolean: 'text-syntax-boolean',
  null: 'text-syntax-null',
  punctuation: 'text-syntax-punct',
};
